/** Min size for betting search */
export const MIN_SEARCH_TERM_LENGTH = 3;
